<template>
  <div class="_component-avatar-uploader">
    <div class="_component-container">
      <input type="file" ref="file" class="_uploader-wrap" v-show="!disabled && state !== STATE.LOAD" :accept="acceptTypeStr" @change="handleFileChange" />
      <component-image className="lazy-loader" bgSize="cover" v-show="state === STATE.SUCCESS" v-if="value && value.url" type="bg" :src="previewUrl" />
      <div class="_uploader-content ready" v-show="state === STATE.READY"></div>
      <div class="_uploader-content load" v-show="state === STATE.LOAD"></div>
      <div class="_uploader-content error" v-show="state === STATE.ERROR"></div>
    </div>
  </div>
</template>
<script>
import ImageUploader from '../ImageUploader';
export default {
  name: 'Avatar',
  extends: ImageUploader
};
</script>
<style lang="less" scoped src="./index.less"></style>
